import { z } from 'zod';
export const TenantPlanSchema = z.enum(['free', 'starter', 'pro', 'enterprise']);
export const TenantSettingsSchema = z.object({
    currency: z.string().length(3).default('USD'),
    timezone: z.string().default('America/Los_Angeles'),
    branding: z.object({
        logo_url: z.string().url().optional(),
        primary_color: z.string().regex(/^#[0-9A-Fa-f]{6}$/).optional(),
        name: z.string().min(1),
    }),
    notifications: z.object({
        email: z.string().email().optional(),
        sms: z.string().optional(),
        webhook_url: z.string().url().optional(),
    }),
    carbon_tracking_enabled: z.boolean().default(false),
});
export const TenantSchema = z.object({
    _id: z.string(),
    name: z.string().min(1),
    slug: z.string().min(1).regex(/^[a-z0-9-]+$/),
    plan: TenantPlanSchema,
    stripe_customer_id: z.string().optional(),
    stripe_subscription_id: z.string().optional(),
    /** Seat floor declared at website checkout: the per-charger
     *  subscription bills max(live charger count, floor). Informational
     *  for billing only; it never gates a charger add. */
    subscribed_charger_floor: z.number().int().min(0).nullable().optional(),
    /** Stripe Connect account ID for receiving payouts */
    stripe_connect_account_id: z.string().optional(),
    /** True once Connect onboarding has completed (charges/payouts enabled) */
    payment_account_added: z.boolean().default(false),
    /** Strict-ready mirror of User.stripe_connect_charges_enabled.
     *  Resident sharing requires BOTH the building's tenant flag
     *  AND the resident's User flag to be true (Phase 6.2 gate). */
    stripe_connect_charges_enabled: z.boolean().default(false),
    /** Building-join code (Session 8.a). Null when no code is
     *  active; admin generates / regenerates / clears via the
     *  admin CMS. 6-char ambiguous-free alphanumeric, uppercase. */
    join_code: z.string().nullable().optional(),
    join_code_generated_at: z.coerce.date().nullable().optional(),
    /** Per-building toggle for the resident-managed-chargers PWA flow.
     *  Defaults TRUE (opt-out) per the resident-managed discovery. */
    allow_resident_self_registration: z.boolean().default(true),
    settings: TenantSettingsSchema,
    is_active: z.boolean(),
    created_at: z.coerce.date(),
    updated_at: z.coerce.date(),
});
export const CreateTenantSchema = z.object({
    name: z.string().min(1).max(100),
    slug: z.string().min(2).max(50).regex(/^[a-z0-9-]+$/, 'Slug must be lowercase letters, numbers, and hyphens only'),
    plan: TenantPlanSchema.default('free'),
    settings: TenantSettingsSchema.partial().optional(),
});
//# sourceMappingURL=tenant.js.map